import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { 
  OFFICE_STATS_YEAR, OFFICE_STATS_MONTH, OFFICE_STATS_SWITCH, OFFICE_STATS_RESET, OFFICE_STATS_SELECT_DAY, OFFICE_STATS_CHANGE_DATE,
  PENDING, FULFILLED, REJECTED,
} from '../../globals';


export function getOfficeStatsYearRequest(){
  return {
    type: `${OFFICE_STATS_YEAR}_${PENDING}`,
    payload: {
      refresh: true,
    }
  };
}

export function getOfficeStatsYearSuccess(response, data){
  return {
    type: `${OFFICE_STATS_YEAR}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
      year: data.year,
      month: data.month,
    }
  };
}

export function getOfficeStatsYearFailure(response){
  return {
    type: `${OFFICE_STATS_YEAR}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}



export function getOfficeStatsMonthRequest(){
  return {
    type: `${OFFICE_STATS_MONTH}_${PENDING}`,
    payload: {
      refresh: true,
    }
  };
}

export function getOfficeStatsMonthSuccess(response, data){
  return {
    type: `${OFFICE_STATS_MONTH}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
      year: data.year,
      month: data.month,
    }
  };
}

export function getOfficeStatsMonthFailure(response){
  return {
    type: `${OFFICE_STATS_MONTH}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}



export const getOfficeStatsYear = (officeId, serviceId, year, month) => {
  return {
    [CALL_API]: {
      actions: [getOfficeStatsYearRequest, getOfficeStatsYearSuccess, getOfficeStatsYearFailure],
      url: `${API_URL}/web/stats/longterm?store_id=${officeId}&service_id=${serviceId}&year=${year}`,
      addData: {
        year: year,
        month: month,
      },
    },
  }
};


export const getOfficeStatsMonth = (officeId, serviceId, year, month) => {
  return {
    [CALL_API]: {
      actions: [getOfficeStatsMonthRequest, getOfficeStatsMonthSuccess, getOfficeStatsMonthFailure],
      url: `${API_URL}/web/stats/longterm?store_id=${officeId}&service_id=${serviceId}&year=${year}&month=${month}`,
      addData: {
        year: year,
        month: month,
      },
    },
  }
};


export function officeStatsChangeDate(year, month) {
  return {
    type: `${OFFICE_STATS_CHANGE_DATE}`,
    payload: {
      month: month,
      year: year,
    }
  }
};

export function switchOfficeStats(statsChecked, dateChecked) {
  return {
    type: `${OFFICE_STATS_SWITCH}`,
    payload: {
      statsChecked: statsChecked, 
      dateChecked: dateChecked,
    }
  };
};


export function officeStatsReset() {
  return {
    type: `${OFFICE_STATS_RESET}`,
  }
};

export function officeSelectDay(day, month, year) {
  return {
    type: `${OFFICE_STATS_SELECT_DAY}`,
    payload: {
      day: day, 
      month: month,
      year: year,
    }
  }
};
